import React from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  padding-top: var(--header-h);
  min-height: 100vh;
  background: white;
  width: 100%;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px 60px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 30px;
  transition: color 0.3s ease;

  &:hover {
    color: #666;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 30px;
  font-weight: 300;
`;

const Content = styled.div`
  background: white;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  line-height: 1.8;
  color: #333;

  h2 {
    font-size: 1.8rem;
    color: #333;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: 600;
  }

  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-top: 25px;
    margin-bottom: 12px;
    font-weight: 600;
  }

  p {
    margin-bottom: 15px;
    font-size: 1rem;
  }

  ul {
    margin-left: 20px;
    margin-bottom: 15px;
  }

  li {
    margin-bottom: 8px;
  }
`;

const TeslimatIadePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Container>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          Geri Dön
        </BackButton>

        <Title>Teslimat ve İade Şartları</Title>

        <Content>
          <h2>1. Teslimat Koşulları</h2>
          <p>
            Saraylı Moda olarak, siparişlerinizi en kısa sürede ve güvenli bir şekilde teslim etmek için çalışıyoruz.
          </p>

          <h3>1.1. Teslimat Süresi</h3>
          <p>
            Standart teslimat süresi 3-7 iş günüdür. Özel üretim ürünler için teslimat süresi 4-6 hafta arasında değişebilir.
          </p>

          <h3>1.2. Teslimat Ücreti</h3>
          <p>
            ₺10.000 üzeri siparişlerde kargo ücretsizdir. Altındaki siparişlerde kargo ücreti ₺500'dir.
          </p>

          <h3>1.3. Teslimat Adresi</h3>
          <p>
            Siparişiniz, sipariş formunda belirttiğiniz adrese teslim edilir. Adres bilgilerinizin doğru olduğundan emin olun.
          </p>

          <h2>2. İade ve Değişim Koşulları</h2>
          <p>
            Müşteri memnuniyeti bizim için önceliktir. Aşağıdaki koşullar çerçevesinde iade ve değişim işlemlerinizi gerçekleştirebilirsiniz.
          </p>

          <h3>2.1. İade Süresi</h3>
          <p>
            Ürünlerinizi teslimat tarihinden itibaren 14 gün içinde iade edebilirsiniz.
          </p>

          <h3>2.2. İade Koşulları</h3>
          <ul>
            <li>Ürün orijinal ambalajında ve etiketleriyle birlikte olmalıdır</li>
            <li>Ürün kullanılmamış, yıkanmamış ve hasar görmemiş olmalıdır</li>
            <li>Özel üretim ürünlerde iade kabul edilmemektedir</li>
            <li>İade kargo ücreti müşteriye aittir</li>
          </ul>

          <h3>2.3. İade İşlemi</h3>
          <p>
            İade talebinizi info@saraylimoda.com adresine e-posta göndererek veya müşteri hizmetlerimizi arayarak bildirebilirsiniz.
            İade onayından sonra ürünü kargo ile gönderebilirsiniz.
          </p>

          <h3>2.4. İade Ödemesi</h3>
          <p>
            İade işlemi onaylandıktan sonra, ödeme yaptığınız yönteme göre 3-5 iş günü içinde iade tutarı hesabınıza yansıtılır.
          </p>

          <h2>3. İletişim</h2>
          <p>
            Teslimat ve iade konularında sorularınız için bizimle iletişime geçebilirsiniz:
          </p>
          <p>
            <strong>E-posta:</strong> info@saraylimoda.com<br />
            <strong>Telefon:</strong> 0224 221 51 20
          </p>
        </Content>
      </Container>
    </PageContainer>
  );
};

export default TeslimatIadePage;

